/**
 * vion-icon v1.0.1
 * (c) 2023 yangling
 * @license MIT
 */

import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, createElementVNode } from 'vue';

var CheckCircle = defineComponent({
  name: "CheckCircle",
  props: {
    color: String,
    size: String
  },
  emits: ["click"],
  setup: function setup(props, ctx) {
    var iconStyle = computed(function () {
      return {
        display: "inline-block",
        fontSize: props.size,
        color: props.color,
        width: "1em",
        height: "1em",
        lineHeight: "1em"
      };
    });
    var click = function click(e) {
      return ctx.emit("click", e);
    };
    return {
      iconStyle: iconStyle,
      click: click
    };
  }
});
CheckCircle.install = function (app) {
  app.component(CheckCircle.name, CheckCircle);
};

var _hoisted_1 = /* @__PURE__ */createElementVNode("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [/* @__PURE__ */createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M24 8C32.8366 8 40 15.1634 40 24C40 32.8366 32.8366 40 24 40C15.1634 40 8 32.8366 8 24C8 15.1634 15.1634 8 24 8ZM24 4C35.0457 4 44 12.9543 44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4ZM32.188 17.1589L35.0164 19.9874L25.1169 29.8869L22.2885 32.7153L19.4601 29.8869L14.5103 24.9371L17.3387 22.1087L22.2885 27.0584L32.188 17.1589Z",
  fill: "currentColor"
})], -1);
var _hoisted_2 = [_hoisted_1];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: "v-icon",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.click && _ctx.click.apply(_ctx, arguments);
    }),
    style: normalizeStyle(_ctx.iconStyle)
  }, _hoisted_2, 4);
}

CheckCircle.render = render;

export { CheckCircle as default };
